(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  } 

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iqos-flavours"] && !Shopify.designMode) return;
  try {
    
   (function () {
     let mild = document.getElementById('mild-toggle');
     let regular = document.getElementById('regular-toggle');
     let bold = document.getElementById('bold-toggle');
     let scroller = document.querySelector('.c05-flavors__scroller');
     let width = document.querySelector('.c05-flavors__taste-wrapper');
     let maxScroll = ((scroller.scrollWidth - scroller.clientWidth));


     scroller.addEventListener('scroll', function (event) {
  let scroller = event.target;
       let maxScroll = ((scroller.scrollWidth - scroller.clientWidth));

       if (scroller.scrollLeft < (scroller.offsetWidth * 0.33)) {
         document.querySelectorAll('.c05-flavors__tab').forEach((node) => {
           node.classList.remove('c05-flavors__tab--active')
         })
         mild.classList.add('c05-flavors__tab--active')
       }
       if (scroller.scrollLeft > (maxScroll * 0.33) && scroller.scrollLeft < (maxScroll * 0.66)) {
         document.querySelectorAll('.c05-flavors__tab').forEach((node) => {
           node.classList.remove('c05-flavors__tab--active')
         })
         regular.classList.add('c05-flavors__tab--active')
       }
       if (scroller.scrollLeft > (maxScroll * 0.66)) {
         document.querySelectorAll('.c05-flavors__tab').forEach((node) => {
           node.classList.remove('c05-flavors__tab--active')
         })
         bold.classList.add('c05-flavors__tab--active')
       }

       if (scroller.scrollLeft < (scroller.offsetWidth * 0.33)) {
         document.querySelector('.c05-flavors__tabs-left-arrow').style.opacity = "0.5"
         document.querySelector('.c05-flavors__tabs-right-arrow').style.opacity = "1"
       }
       if (scroller.scrollLeft > (maxScroll * 0.33) && scroller.scrollLeft < (maxScroll * 0.66)) {
         document.querySelector('.c05-flavors__tabs-left-arrow').style.opacity = "1"
         document.querySelector('.c05-flavors__tabs-right-arrow').style.opacity = "1"
       }
       if (scroller.scrollLeft > (maxScroll * 0.66)) {
         document.querySelector('.c05-flavors__tabs-left-arrow').style.opacity = "1"
         document.querySelector('.c05-flavors__tabs-right-arrow').style.opacity = "0.5"
       }
     });


     mild.classList.add('c05-flavors__tab--active')
  document.querySelector('.c05-flavors__tabs-left-arrow').style.opacity = "0.5"
     document.querySelector('.c05-flavors__tabs-right-arrow').style.opacity = "1"

     mild.addEventListener('click', function () {
       document.querySelectorAll('.c05-flavors__tab').forEach((node) => {
         node.classList.remove('c05-flavors__tab--active')
       })
       mild.classList.add('c05-flavors__tab--active')
       toggleScroller('mild')
     })
     regular.addEventListener('click', function () {
       document.querySelectorAll('.c05-flavors__tab').forEach((node) => {
         node.classList.remove('c05-flavors__tab--active')
       })
       regular.classList.add('c05-flavors__tab--active')
       toggleScroller('regular')
     })
     bold.addEventListener('click', function () {
       document.querySelectorAll('.c05-flavors__tab').forEach((node) => {
         node.classList.remove('c05-flavors__tab--active')
       })
       bold.classList.add('c05-flavors__tab--active')
       toggleScroller('bold')
     })
   })();

   function toggleScroller(option) {
     let scroller = document.querySelector('.c05-flavors__scroller');
     let maxScroll = ((scroller.scrollWidth - scroller.clientWidth));
     if (option === 'mild') {
       scroller.scrollLeft = 0;
     }
     if (option === 'regular') {
       scroller.scrollLeft = maxScroll * 0.55;
     }
     if (option === 'bold') {
       scroller.scrollLeft = maxScroll;
     }
   }

  } catch(e) { console.error(e); }
})();
})();
